import React, { useContext } from 'react';
import { assertNotNull } from '../../../../../helpers/nullHelpers';
import { SearchSelectField } from '../../../../../shared/form/inputs/SearchSelectField';
import { QuoteOrDesignFormContext } from '../../QuoteOrDesignFormContext';
import { roomFieldName } from '../../quoteOrDesignFormFieldNameHelpers';

type Props = {
  unitIndex: number;
  manifoldIndex: number;
  roomIndex: number;
  isWithinRadiatorManifold: boolean;
};

export const RoomFloorConstructionField = ({
  unitIndex,
  manifoldIndex,
  roomIndex,
  isWithinRadiatorManifold,
}: Props) => {
  const formContext = assertNotNull(useContext(QuoteOrDesignFormContext));
  const { roomFloorConstructionOptions } = formContext.referenceData;

  if (isWithinRadiatorManifold) {
    return null;
  }

  return (
    <SearchSelectField
      name={roomFieldName(unitIndex, manifoldIndex, roomIndex, 'floorConstruction')}
      label="Construction"
      options={roomFloorConstructionOptions}
      mapValueToKey={value => value.partId.toString()}
    />
  );
};
